import { CustomerRestrictionsResponse } from 'services/cm-api/get-customer'
import { DefaultPlan } from 'services/cm-api/get-default-plans'
import { findPlanExceptions } from './plan-exceptions'
import {
  ExceptionType,
  FormatDataTypes,
  UpdateCustomerTypes,
} from './restrictions.types'

// ENG2-2455 (T4): the comparison lives in plan-exceptions.ts. This wrapper
// keeps the old signature for callers that have no customer country.
export const findExceptions = (
  customerPlanData?: CustomerRestrictionsResponse,
  defaultsForPlan?: Partial<DefaultPlan>,
): ExceptionType[] =>
  findPlanExceptions(
    customerPlanData,
    defaultsForPlan as DefaultPlan | undefined,
    undefined,
  )

const handleFormatTheUpdateData = ({
  newValue,
  location,
  key,
}: FormatDataTypes) => {
  if (location) {
    return {
      rights: {
        [location]: {
          [key]: newValue,
        },
      },
    }
  }
  return {
    [key]: newValue,
  }
}

export const handleUpdateRestrictions = ({
  selectedCustomer,
  updateCustomer,
  newValue,
  element,
}: UpdateCustomerTypes) => {
  updateCustomer({
    companyId: selectedCustomer,
    reqBody: {
      data: handleFormatTheUpdateData({
        newValue,
        location: element.updateLocation || '',
        key: element.key,
      }),
    },
  })
}
